import { routes } from "utils/Routes";
import { Layout } from "Layout";
import { AboutUs, ContactUs, Innovation, Home } from "pages";

export const Router = [
  {
    path: routes.home,
    Component: Home,
    Layout: Layout,
  },
  {
    path: routes.innovation,
    Component: Innovation,
    Layout: Layout,
  },
  {
    path: routes.about,
    Component: AboutUs,
    Layout: Layout,
  },
  {
    path: routes.contactUs,
    Component: ContactUs,
    Layout: Layout,
  },
];
